import React, { useState } from "react";
import { FaPlay } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Official: React.FC = () => {
  const IconPlay = FaPlay as React.FC<React.SVGProps<SVGSVGElement>>;
  const [openVideo, setOpenVideo] = useState(false);

  const videoId = "zRw8AUtmyiI";
  const campaignLink = "https://belaskasih.com";

  return (
    <section className="pb-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* ================= OFFICIAL PARTNERSHIP ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* ===== VIDEO (KIRI DI DESKTOP, BAWAH DI MOBILE) ===== */}
          <div className="relative group cursor-pointer order-2 md:order-1" onClick={() => setOpenVideo(true)}>
            <img src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`} alt="Video Belas Kasih" className="rounded-2xl shadow-xl w-full" />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40 rounded-2xl flex items-center justify-center">
              <div className="bg-red-600 p-5 rounded-full text-white text-2xl group-hover:scale-110 transition">
                <IconPlay />
              </div>
            </div>
          </div>

          {/* ===== DESKRIPSI (KANAN DI DESKTOP, ATAS DI MOBILE) ===== */}
          <div className="order-1 md:order-2">
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 max-sm:text-center">
              Official <span className="font-bilbo text-red-600">Partnership</span>
            </h1>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed text-justify">
              <strong>Bangkit Berdaya</strong> bekerja sama dengan <strong>Belas Kasih</strong> sebagai platform <span className="font-semibold text-red-600">crowdfunding</span> yang berfokus pada penggalangan dana sosial, kemanusiaan, dan
              kebencanaan di Indonesia.
            </p>

            <p className="text-gray-700 text-base md:text-lg leading-relaxed mt-4 text-justify">
              <strong>Belas Kasih</strong> berperan sebagai jembatan antara <span className="font-semibold text-red-600">donatur</span> dan masyarakat yang membutuhkan melalui kolaborasi dengan berbagai mitra, lembaga, dan komunitas,
              sehingga bantuan dapat tersalurkan secara transparan, cepat, dan tepat sasaran.
            </p>

            {/* <p className="text-gray-700 text-lg leading-relaxed mt-4 text-justify">
              Program-program yang dihadirkan mencakup bantuan kemiskinan, pendidikan, kesehatan, hingga respons darurat bencana alam, dengan semangat gotong royong dan kepedulian bersama.
            </p> */}

            {/* ===== CTA ===== */}
            <div className="mt-8 max-sm:flex max-sm:justify-center">
              <Link to={campaignLink} target="_blank" className="inline-block border border-red-600 text-red-600 px-6 py-3 rounded-xl hover:bg-red-600 hover:text-white transition">
                Kunjungi Belas Kasih
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MODAL VIDEO ================= */}
      {openVideo && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4">
          <div className="relative w-full max-w-4xl">
            <button className="absolute -top-10 right-0 text-white text-3xl" onClick={() => setOpenVideo(false)}>
              ✕
            </button>

            <div className="aspect-video">
              <iframe src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} title="Video Belas Kasih" allow="autoplay; encrypted-media" allowFullScreen className="w-full h-full rounded-xl" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Official;
